import { getLoanById } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router-dom';

import { LoanAssetDetails } from '@/components/modules/AssetDetails/components/LoanAssetDetails/LoanAssetDetails';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { ApplicationType, ModuleCorePermissionProps, PendingDataType } from '@/config/types';
import { useCache } from '@/hooks/requests/useCache';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

interface AssetDetailsProps extends ModuleCorePermissionProps {
  applicationType: ApplicationType;
}

const AssetDetails = ({ canEdit = false, applicationType }: AssetDetailsProps) => {
  const { loanId } = useParams();

  if (!loanId) return null;

  const { data: loan } = useCache(getLoanById, { loanId });

  const assetId = loan?.assetReference[0].id;
  const assetType = loan?.assetReference[0].type;

  if (!loan) return null;

  if (!assetId || !assetType) return <PendingDataWarning type={PendingDataType.DEFAULT} />;

  return (
    <>
      {(applicationType === ApplicationType.CONSUMER_LOAN ||
        applicationType === ApplicationType.AUTO ||
        applicationType === ApplicationType.CARD) && (
        <LoanAssetDetails assetId={assetId} assetType={assetType} editModeAllowed={canEdit} />
      )}
    </>
  );
};

export const AssetDetailsModule = withPermissionsModule(AssetDetails);
